import { X, ArrowLeft, MessageCircle } from 'lucide-react';

// Extraído de WhatsAppPanel.jsx (02.3-client.md paso b) -- el div de header tenía 2 variantes
// condicionadas por `activeChat` (avatar+nombre+volver, vs. título+badge "Conectado"+
// desvincular), más la barra de carga superpuesta. Estilos inline preservados verbatim
// (conversión a tokens es el paso `e`).
export default function WhatsAppHeader({
  activeChat, onBack, status, onClose, onLogout, showLoadingBar,
}) {
  return (
    <div style={{
      padding: 'var(--space-4)',
      background: '#1c1c1e',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '60px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Style block for loading bar keyframes */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes whatsLoadingPulse {
          0% { left: -30%; width: 30%; }
          50% { left: 40%; width: 45%; }
          100% { left: 100%; width: 30%; }
        }
      ` }} />

      {/* Linear WhatsApp green loading bar */}
      {showLoadingBar && (
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: '2px',
          background: '#25d366',
          animation: 'whatsLoadingPulse 1.5s infinite ease-in-out',
          zIndex: 10,
          boxShadow: '0 0 8px #25d366'
        }} />
      )}
      {activeChat ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)', width: '100%' }}>
          <button
            onClick={onBack}
            aria-label="Volver a chats"
            style={{
              background: 'transparent',
              border: 'none',
              color: '#f97316',
              cursor: 'pointer',
              padding: 'var(--space-1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'background .2s'
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <ArrowLeft size={18} />
          </button>
          <div style={{
            width: '34px',
            height: '34px',
            borderRadius: '50%',
            background: '#333',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '600',
            color: '#fff',
            fontSize: '14px',
            flexShrink: 0
          }}>
            {activeChat.avatar_url && activeChat.avatar_url !== 'no_avatar' ? (
              <img src={activeChat.avatar_url} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
            ) : (
              (activeChat.name || '?')[0].toUpperCase()
            )}
          </div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ fontWeight: '600', fontSize: '14px', color: '#f3f4f6', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {activeChat.name || 'Chat'}
            </div>
            <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {activeChat.chat_jid.split('@')[0]}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
            <MessageCircle size={18} style={{ color: '#f97316' }} />
            <span style={{ fontWeight: '700', fontSize: '15px', letterSpacing: '0.3px', color: '#f3f4f6' }}>WhatsApp Inbox</span>
          </div>
          {status === 'connected' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
              <span style={{
                fontSize: '11px',
                background: 'rgba(34, 197, 94, 0.1)',
                color: '#4ade80',
                padding: 'var(--space-1) var(--space-2)',
                borderRadius: 'var(--radius-lg)',
                border: '1px solid rgba(34, 197, 94, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-1)'
              }}>
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e', display: 'inline-block' }}></span>
                Conectado
              </span>

              <button
                onClick={onLogout}
                title="Cerrar sesión / Desvincular"
                style={{
                  background: 'transparent',
                  color: 'rgba(239, 68, 68, 0.6)',
                  cursor: 'pointer',
                  fontSize: '11px',
                  padding: 'var(--space-1) var(--space-2)',
                  borderRadius: 'var(--radius-lg)',
                  border: '1px solid rgba(239, 68, 68, 0.2)',
                  transition: 'all .2s'
                }}
                onMouseEnter={e => { e.currentTarget.style.color = '#ef4444'; e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'rgba(239, 68, 68, 0.6)'; e.currentTarget.style.background = 'transparent'; }}
              >
                Desvincular
              </button>
            </div>
          )}
        </>
      )}
      {!activeChat && (
        <button
          onClick={onClose}
          aria-label="Cerrar WhatsApp"
          style={{
            background: 'transparent',
            border: 'none',
            color: 'rgba(255, 255, 255, 0.4)',
            cursor: 'pointer',
            padding: 'var(--space-1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#fff'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.4)'}
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
}
